import { render } from "./PrivacyConfig.vue?vue&type=template&id=147453a9"
import script from "./PrivacyConfig.vue?vue&type=script&lang=js"
export * from "./PrivacyConfig.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__